import { inject, observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import React from 'react';
import { LocaleStore, MunicipalityStore } from '../../../store';
import withTranslate from '../../common/WithTranslate';
import { MunicipalityForm } from './MunicipalityForm';

interface MunicipalityCreationProps {
  MunicipalityStore?: Instance<typeof MunicipalityStore>;
  LocaleStore?: Instance<typeof LocaleStore>;
}

interface MunicipalityCreationState {}

@inject('MunicipalityStore', 'LocaleStore')
@observer
class MunicipalityCreation extends React.Component<MunicipalityCreationProps, MunicipalityCreationState> {
  render() {
    return (
      <MunicipalityForm
        onSave={(municipality) => this.props.MunicipalityStore!.createMunicipality(municipality)}
        isCreation
      />
    );
  }
}

export default withTranslate(MunicipalityCreation);
